/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Option_OriginalInputs */



/**
* | output |
* | --- |
* | "Source Text" |
*
* @param {Compare_Event_Groups_Option_OriginalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_option_original = /** @type {((inputs?: Compare_Event_Groups_Option_OriginalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Option_OriginalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Texte source")
	if (locale === "de") return /** @type {LocalizedString} */ ("Quelltext")
	if (locale === "it") return /** @type {LocalizedString} */ ("Testo originale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Исходный текст")
	if (locale === "es") return /** @type {LocalizedString} */ ("Texto fuente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("原文")
	if (locale === "ja") return /** @type {LocalizedString} */ ("原文")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्रोत इबारत")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Texto original")
	return /** @type {LocalizedString} */ ("Source Text")
});